export default "__VITE_ASSET__dp$V4hpH__"